import { render, staticRenderFns } from "./FixedDesks.vue?vue&type=template&id=a011dae6&"
import script from "./FixedDesks.vue?vue&type=script&lang=js&"
export * from "./FixedDesks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports